import React from 'react';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';

import './statistic-blocks.scss';

function renderBody(block, i) {
  const body = [];

  if (block.body != null) {
    body.push(
      <p key={++i} className="body-copy">{block.body}</p>
    );
  }

  return body;
}
function renderBullets(block, key) {
  const listItems = [];

  if (block.bullets) {
    if (block.bullets.length > 1) {
      block.bullets.map((item, i) => {
        return listItems.push(
          <li key={i} >{item.bullet}</li>
        )
      })
      
      return <ul key={key} className="body-copy">{listItems}</ul>;
    } else {
      return <p key={key} className="body-copy">{block.bullets[0].bullet}</p>;
    }
  }
}

function renderImage(imageData) {
  if(imageData) {
    return (
      <PreviewCompatibleImage
        customClassName={ "icon" }
        imageInfo={imageData}
        alt="icon"
      />
    )
  }
}

function renderBlocks(blocks) {
  const allBlocksHTML = [];
  
  blocks.forEach((block, i) => {
    const blockHTML = [];
    if (block.headline || block.body) {
      blockHTML.push(
        <div key={i} className="statistic-blocks__copy-blocks__block">
          {renderImage(block.image)}
          {block.headline ? <h3 className="headline">{block.headline}</h3> : ''}
          {block.headline2 ? <h3 className="subhead">{block.headline2}</h3> : ''}
          {renderBody(block, i)}
          {renderBullets(block, i)}
        </div>
      )
    }

    allBlocksHTML.push(blockHTML);
  })

  return allBlocksHTML;
}

const statisticBlocks = ({ blocks }) => {
  return (
    <div className="statistic-blocks__copy-blocks">
      {renderBlocks(blocks)}
    </div>
  )
}

export default statisticBlocks
